import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  Dimensions,
  TouchableHighlight,
  TouchableOpacity,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Theme from "../argon-ui/Theme";
import ArButton from "../argon-ui/Button";
import { translate } from "../locales/translate";
import HorizontalIconPicker from "../components_v2/HorizontalIconPicker";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import { IconButton, SimpleIcon } from "../components_v2/Buttons";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import Loading from "../components/Loading";
import { Platform } from "react-native";
import * as AreaActions from "../actions/AreaActions";
const HEIGHT = Dimensions.get("screen").height;
const STATES = {
  ON_ACTIVATE: "onActivate",
  ON_DEACTIVATE: "onDeActivate",
};
import Switch from "../components/ToggleSwitch";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ModalBase from "../nativeBase-ui/ModalBase";
import { getDir } from "../util";
class AreaStateFormScreen extends Component {
  constructor(props) {
    super(props);
    this.iconsList = [
      faCharCodes.faPowerOff,
      faCharCodes.faHome,
      faCharCodes.faHomeAlt,
      faCharCodes.faHomeHeart,
      faCharCodes.faParking,
      faCharCodes.faParkingSlash,
      faCharCodes.faParkingCircle,
      faCharCodes.faParkingCircleSlash,
      faCharCodes.faShield,
      faCharCodes.faShieldAlt,
      faCharCodes.faShieldCheck,
      faCharCodes.faShieldCross,
      faCharCodes.faShieldVirus,
      faCharCodes.faUserShield,
      faCharCodes.faLock,
      faCharCodes.faLockOpen,
      faCharCodes.faBell,
      faCharCodes.faBells,
      faCharCodes.faBellExclamation,
      faCharCodes.faBellSlash,
      faCharCodes.faRadiation,
      faCharCodes.faSyncAlt,
      faCharCodes.faRecycle,
      faCharCodes.faFilm,
      faCharCodes.faTv,
      faCharCodes.faTvMusic,
      faCharCodes.faTvRetro,
      faCharCodes.faTheaterMasks,
      faCharCodes.faMusic,
      faCharCodes.faMusicSlash,
      faCharCodes.faGuitar,
      faCharCodes.faGuitarElectric,
      faCharCodes.faGuitars,
      faCharCodes.faVolumeUp,
      faCharCodes.faVolume,
      faCharCodes.faVolumeDown,
      faCharCodes.faVolumeOff,
      faCharCodes.faVolumeMute,
      faCharCodes.faVolumeSlash,
      faCharCodes.faWind,
      faCharCodes.faFan,
      faCharCodes.faLightbulb,
      faCharCodes.faLightbulbDollar,
      faCharCodes.faLightbulbExclamation,
      faCharCodes.faLightbulbOn,
      faCharCodes.faLightbulbSlash,
      faCharCodes.faLightCeiling,
      faCharCodes.faBirthdayCake,
      faCharCodes.faUtensils,
      faCharCodes.faCocktail,
      faCharCodes.faGlassCheers,
      faCharCodes.faCoffee,
      faCharCodes.faSeedling,
      faCharCodes.faGamepadAlt,
      faCharCodes.faClock,
      faCharCodes.faEye,
      faCharCodes.faEyeSlash,
      faCharCodes.faMagic,
      faCharCodes.faWandMagic,
      faCharCodes.faTint,
      faCharCodes.faTintSlash,
      faCharCodes.faChalkboardTeacher,
      faCharCodes.faWalking,
      faCharCodes.faRunning,
      faCharCodes.faDumbbell,
      faCharCodes.faDoorOpen,
      faCharCodes.faDoorClosed,
      //faCharCodes.faSignIn,
      faCharCodes.faSignInAlt,
      //faCharCodes.faSignOut,
      faCharCodes.faSignOutAlt,
      faCharCodes.faBroom,
      faCharCodes.faHammer,
      faCharCodes.faCogs,
      faCharCodes.faMinusCircle,
      faCharCodes.faMinusHexagon,
      faCharCodes.faFlag,
      faCharCodes.faFlagCheckered,
      faCharCodes.faFlagAlt,
      // ===
      faCharCodes.faWaterRise,
      faCharCodes.faWaterLower,
      faCharCodes.faBolt,

      faCharCodes.faRadiationAlt,
      faCharCodes.faRadiation,
      faCharCodes.faRadiationAlt,
      faCharCodes.faSiren,
      faCharCodes.faSirenOn,
      faCharCodes.faExclamationTriangle,
      faCharCodes.faExclamation,
      faCharCodes.faExclamationCircle,
      faCharCodes.faSkullCrossbones,

      faCharCodes.faTemperatureUp,
      faCharCodes.faTemperatureDown,
      faCharCodes.faOilTemp,

      faCharCodes.faCarGarage,

      faCharCodes.faFireSmoke,
      faCharCodes.faSensorFire,

      faCharCodes.faGarage,
      faCharCodes.faGarageOpen,

      faCharCodes.faTruckMoving,
      faCharCodes.faDigging,
      faCharCodes.faFire,

      faCharCodes.faHeartRate,
      faCharCodes.faIndustryAlt,
      faCharCodes.faIndustry,
      faCharCodes.faFaucetDrip,
      faCharCodes.faFaucet,
    ];

    this.allIntervalTypes = ["second", "minute", "hour"];

    let { areaId, areaUId, areaName, id, uId, currentDevicesType } =
      this.props.navigation.state.params;
    this.allowedDeviceTypes = [
      DeviceTypes.LIGHT,
      DeviceTypes.LIGHT_DIMMER,
      DeviceTypes.OUTLET,
      DeviceTypes.POWER_SWITCH,
      DeviceTypes.HIDDEN_SWITCH,
      DeviceTypes.CURTAIN,
      DeviceTypes.AIR_CONDITIONER,
      DeviceTypes.DOORLOCK,
      DeviceTypes.ELEVATOR,
      DeviceTypes.MULTIMEDIA,
      DeviceTypes.WATERING_SWITCH,
      DeviceTypes.SIREN,
    ];
    this.unacceptableDeviceTypeUpdateValue = [DeviceTypes.DOORLOCK];

    this.actionManagers = this.props.AreaReducer.actionManagers
      .filter((act) =>
        this.allowedDeviceTypes.some((t) => act.deviceType.indexOf(t) >= 0)
      )
      .map((act) => {
        return {
          manager: act.manager,
          deviceType: act.deviceType,
          deviceActivator: act.actions
            .filter((a) => !a.isBatchAction && a.isDeviceActivator)
            .map((a) => a.action)[0],
          deviceDeActivator: act.actions
            .filter((a) => !a.isBatchAction && a.isDeviceDeActivator)
            .map((a) => a.action)[0],
          deviceBatchActivator: act.actions
            .filter((a) => a.isBatchAction && a.isDeviceActivator)
            .map((a) => a.action)[0],
          deviceBatchDeActivator: act.actions
            .filter((a) => a.isBatchAction && a.isDeviceDeActivator)
            .map((a) => a.action)[0],
        };
      });

    this.state = {
      accessToken: "",
      id: id || 0,
      uId: uId || "",
      name: "",
      shouldConfirm: false,
      canShowOnHomeScreen: false,
      canShowOnHomeScreenArea: true,
      canChangeByUsers: true,
      activeIcon: this.iconsList[0],
      deActiveIcon: this.iconsList[0],
      autoDisableIntervalType: "second",
      autoDisableIntervalDuration: 0,
      autoDisable: false,
      areaId,
      areaUId,
      areaName,
      currentDevicesType,
      areaDevices: [], // list of all devices
      devicesStatus: [],
      scenariosToRun: [],
      showOnActivationIconPicker: false,
      showOnDeActivationIconPicker: false,
      isLoading: true,
      showPickDeviceModal: false,
      modalMode: STATES.ON_ACTIVATE,

      validation_stateName_hasError: false,
      validation_duration_hasError: false,
      validationErrors: [],
      showingValidationErrors: false,
      showingDeleteConfirm: false,
      allowedDeviceTypes: this.allowedDeviceTypes,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreaStates"),
  });
  async componentDidMount() {
    var { currentServer } = this.props.AppReducer;
    const accessToken = currentServer.accessToken;
    if (this.state.areaId || this.state.stateUId) {
      let areaDevices = await this.loadAreaDevices();
      // load model
      if (this.state.id || this.state.uId) {
        var model = await this.loadAreaState();
        if (model) {
          let {
            name,
            shouldConfirm,
            canShowOnHomeScreen,
            canShowOnHomeScreenArea,
            canChangeByUsers,
            activeIcon,
            deActiveIcon,
            autoDisableIntervalType,
            autoDisableIntervalDuration,
            devicesStatus,
            scenariosToRun,
          } = model;
          for (var i in devicesStatus) {
            devicesStatus[i].value =
              (
                this.actionManagers.filter(
                  (m) => m.manager == devicesStatus[i].manager
                )[0] || {}
              ).deviceActivator == devicesStatus[i].action ||
              (
                this.actionManagers.filter(
                  (m) => m.manager == devicesStatus[i].manager
                )[0] || {}
              ).deviceBatchActivator == devicesStatus[i].action
                ? 255
                : 0;
          }
          this.setState({
            accessToken,
            isLoading: false,
            areaDevices,
            name,
            shouldConfirm,
            canShowOnHomeScreen,
            canShowOnHomeScreenArea,
            canChangeByUsers,
            activeIcon,
            deActiveIcon,
            autoDisable: autoDisableIntervalDuration > 0,
            autoDisableIntervalType,
            autoDisableIntervalDuration,
            devicesStatus,
            scenariosToRun,
          });
        } else {
          this.setState({
            accessToken,
            isLoading: false,
            areaDevices,
          });
        }
      } else if (this.state.currentDevicesType) {
        let sections = this.createSections(areaDevices);
        const filterDeviceByCurrentDevicesType = sections.filter((section) =>
          this.state.currentDevicesType.some((item) => {
            const findActionManagerByDeviceType = this.actionManagers.find(
              (action) => action.manager === section.manager
            );

            return (
              findActionManagerByDeviceType &&
              findActionManagerByDeviceType.deviceType.includes(item)
            );
          })
        );
        filterDeviceByCurrentDevicesType.forEach((element) => {
          element?.data.forEach((elementData) => {
            this.toggleDevice(
              elementData.deviceId,
              elementData.deviceUId,
              element.manager,
              STATES.ON_ACTIVATE,
              element.deviceType,
              elementData.currentValue ? 255 : 0
            );
          });
        });
        this.setState({
          accessToken,
          isLoading: false,
          areaDevices,
        });
      } else {
        this.setState({
          accessToken,
          isLoading: false,
          areaDevices,
        });
      }
    } else {
      this.props.navigation.goBack();
    }
  }

  validateForm() {
    // definition
    let isValid = true,
      validation_duration_hasError = false,
      validation_stateName_hasError = false,
      validationErrors = [];
    // validation
    if (!this.state.name) {
      validation_stateName_hasError = true;
      validationErrors.push(translate("areaState.enterStateName"));
    }
    if (this.state.autoDisable && this.state.autoDisableIntervalDuration <= 0) {
      validation_duration_hasError = true;
      validationErrors.push(translate("areaState.enterAutoDisableDuration"));
    }

    // set state
    this.setState({
      validation_duration_hasError,
      validation_stateName_hasError,
      validationErrors,
    });

    // return result
    isValid = !validation_duration_hasError && !validation_stateName_hasError;

    return isValid;
  }

  save = () => {
    if (this.validateForm()) {
      // send data to server
      let {
        id,
        uId,
        areaId,
        areaUId,
        name,
        activeIcon,
        deActiveIcon,
        autoDisable,
        autoDisableIntervalDuration,
        autoDisableIntervalType,
        devicesStatus,
        scenariosToRun,
        accessToken,
        canShowOnHomeScreen,
        canShowOnHomeScreenArea,
        canChangeByUsers,
        shouldConfirm,
      } = this.state;

      var model = {
        id,
        uId,
        areaId,
        areaUId,
        name,
        activeIcon,
        deActiveIcon,
        autoDisableIntervalType: autoDisableIntervalType || "second",
        autoDisableIntervalDuration: autoDisable
          ? autoDisableIntervalDuration
          : 0,
        devicesStatus,
        scenariosToRun,
        canShowOnHomeScreen,
        canShowOnHomeScreenArea,
        canChangeByUsers,
        shouldConfirm,
      };
      if (id || uId) {
        this.props.updateState(model, accessToken);
      } else {
        this.props.addState(model, accessToken);
      }
      this.props.navigation.goBack();
    } else {
      this.showValidationAlert();
    }
  };

  loadAreaDevices = () => {
    return new Promise((resolve) => {
      if (this.state.areaId || this.state.areaUId) {
        for (var i in this.props.AreaReducer.areas) {
          var a = this.props.AreaReducer.areas[i];
          if (
            a.areaId == this.state.areaId ||
            a.areaUId == this.state.areaUId
          ) {
            var areaDevices = a.devices || a.uDevices;
            var validDevices = this.props.DeviceReducer.list
              .filter(
                (d) =>
                  areaDevices.includes(d.deviceId || d.deviceUId) &&
                  this.state.allowedDeviceTypes.includes(d.deviceType) &&
                  !d.statusRelayId // ignore airConditioner control relays
              )
              .map((d) => {
                return {
                  deviceId: d.deviceId,
                  deviceUId: d.deviceUId,
                  deviceName: d.deviceName,
                  deviceType: d.deviceType,
                  currentValue: d?.isTurnedOn || !!d?.value,
                };
              });
            resolve(validDevices);
            return;
          }
        }
      } else {
        resolve([]);
      }
    });
  };

  loadAreaState = () => {
    return new Promise((resolve) => {
      let { areaId, areaUId, id, uId } = this.state;
      if ((areaId && id) || (areaUId && uId)) {
        var area = this.props.AreaReducer.areas.find(
          (a) => a.areaId == areaId || a.areaUId == areaUId
        );
        if (area && Array.isArray(area.userDefinedStates)) {
          var areaState = area.userDefinedStates.find(
            (s) => s.id == id || s.uId == uId
          );
          if (areaState) resolve(areaState);
          else resolve(null);
        } else {
          resolve(null);
        }
      } else {
        resolve(null);
      }
      resolve(null);
    });
  };

  toggleDevice = (
    deviceId,
    deviceUId,
    manager,
    state = STATES.ON_ACTIVATE,
    deviceType,
    value = 255
  ) => {
    var action = "";
    if (!deviceId || !deviceUId) {
      action = this.actionManagers.find(
        (m) => m.manager == manager
      )?.deviceBatchActivator;
    } else {
      const _action = this.actionManagers.find((m) => m.manager == manager);
      if (_action) {
        action =
          value === 255 ? _action.deviceActivator : _action.deviceDeActivator;
      }
    }
    let devicesStatus = [...this.state.devicesStatus];
    var existed = devicesStatus.find(
      (d) =>
        (d.deviceId == deviceId || d.deviceUId == deviceUId) &&
        d.manager == manager &&
        d.triggerName.toLowerCase() == state.toLowerCase()
    );
    if (existed) {
      var idx = devicesStatus.indexOf(existed);
      devicesStatus.splice(idx, 1);
    } else {
      devicesStatus.push({
        id: 0,
        uId: "",
        areaStateId: this.state.id,
        areaStateUId: this.state.uId,
        deviceId,
        deviceUId,
        manager,
        action,
        triggerName: state,
        deviceType,
        value,
      });
    }
    if (!deviceId || !deviceUId) {
      var filterDeviceStatus = devicesStatus.filter((d) => {
        if (
          (d.deviceId != null || d.deviceUId != null) &&
          d.manager == manager &&
          d.triggerName == state
        ) {
          return null;
        } else {
          return d;
        }
      });
      devicesStatus = filterDeviceStatus;
    }
    this.setState({ devicesStatus });
  };

  toggleScenario = (
    scenarioId,
    scenarioUId,
    scenarioName,
    state = STATES.ON_ACTIVATE
  ) => {
    let scenariosToRun = [...this.state.scenariosToRun];
    var existed = scenariosToRun.find(
      (s) =>
        (s.scenarioId == scenarioId || s.scenarioUId == scenarioUId) &&
        s.triggerName.toLowerCase() == state.toLowerCase()
    );
    if (existed) {
      scenariosToRun.splice(scenariosToRun.indexOf(existed), 1);
    } else {
      scenariosToRun.push({
        id: 0,
        uId: "",
        areaStateId: this.state.id,
        areaStateUId: this.state.uId,
        scenarioId,
        scenarioUId,
        scenarioName,
        triggerName: state,
      });
    }
    this.setState({ scenariosToRun });
  };

  getDeviceTypeIcon = (deviceType) => {
    switch (deviceType) {
      case DeviceTypes.LIGHT:
      case DeviceTypes.LIGHT_DIMMER:
        return faCharCodes.faLightbulb;
      case DeviceTypes.OUTLET:
        return faCharCodes.faOutlet;
      case DeviceTypes.POWER_SWITCH:
      case DeviceTypes.HIDDEN_SWITCH:
        return faCharCodes.faLightSwitch;
      case DeviceTypes.CURTAIN:
        return faCharCodes.faBlinds;
      case DeviceTypes.AIR_CONDITIONER:
        return faCharCodes.faAirConditioner;
      case DeviceTypes.ELEVATOR:
        return faCharCodes.faSort;
      case DeviceTypes.DOORLOCK:
        return faCharCodes.faKey;
      case DeviceTypes.WATERING_SWITCH:
        return faCharCodes.faRaindrops;
      default:
        return faCharCodes.faSensor;
    }
  };

  updateDeviceValue = (deviceId, deviceUId, state = STATES.ON_ACTIVATE) => {
    var devicesStatus = [...this.state.devicesStatus];
    var dvc = devicesStatus.find(
      (d) =>
        (d.deviceId == deviceId || d.deviceUId == deviceUId) &&
        d.triggerName.toLowerCase() == state.toLowerCase() &&
        !this.unacceptableDeviceTypeUpdateValue.includes(d.deviceType)
    );
    if (dvc) {
      var manager =
        this.actionManagers.filter((m) => m.manager == dvc.manager)[0] || {};
      var action;
      if (dvc.value == 0) {
        switch (dvc.action) {
          // === check TurnOff => return TurnOn ===
          case dvc.action === manager.deviceDeActivator:
            action = manager.deviceActivator;
            break;
          // === check TurnOffAll => return TurnOnAll ===
          case dvc.action === manager.deviceBatchDeActivator:
            action = manager.deviceBatchActivator;
            break;
          default:
            action = manager.deviceBatchActivator;
        }
        dvc.value = 255;
        dvc.action = action;
      } else if (dvc.value == 255) {
        switch (dvc.action) {
          // === check TurnOn => return TurnOff ===
          case manager.deviceActivator:
            action = manager.deviceDeActivator;
            break;
          // === check TurnOnAll => return TurnOffAll ===
          case manager.deviceBatchActivator:
            action = manager.deviceBatchDeActivator;
            break;
          default:
            action = manager.deviceBatchDeActivator;
        }
        dvc.value = 0;
        dvc.action = action;
      }
      this.setState({ devicesStatus });
    }
  };

  showDeviceModal = (mode = STATES.ON_ACTIVATE) => {
    this.setState({ showPickDeviceModal: true, modalMode: mode });
  };
  deviceBatchType(deviceManager) {
    for (var i in this.state.devicesStatus) {
      if (
        this.state.devicesStatus[i].manager == deviceManager &&
        (this.state.devicesStatus[i].deviceId == null ||
          this.state.devicesStatus[i].deviceUId == null) &&
        this.state.devicesStatus[i].triggerName.toLowerCase() ==
          this.state.modalMode.toLowerCase()
      )
        return true;
    }
    return false;
  }
  createSections = (areaDevices = this.state.areaDevices) => {
    const sections = this.actionManagers
      .filter((man) =>
        areaDevices
          .map((ad) => ad.deviceType)
          .some((adt) => man.deviceType.indexOf(adt) >= 0)
      )
      .map((man) => {
        return {
          title: translate("deviceGroup." + man.deviceType.split(",")[0]), // for example ignore lightDimmer in 'light,lightDimmer' csv
          manager: man.manager,
          deviceActivator: man.deviceActivator,
          deviceDeActivator: man.deviceDeActivator,
          deviceBatchActivator: man.deviceBatchActivator,
          deviceBatchDeActivator: man.deviceBatchDeActivator,
          data: areaDevices.filter(
            (d) => d.deviceType == man.deviceType.split(",")[0]
          ),
        };
      });
    return sections;
  };
  renderModalList = () => {
    var sections = this.createSections();
    let { scenarios } = this.props.ScenarioReducer;
    return (
      <ScrollView
        contentContainerStyle={{ direction: getDir(), paddingHorizontal: 5 }}
      >
        {sections.map((section, i) => {
          return (
            <View key={i} style={{ marginBottom: 10 }}>
              <Text style={styles.deviceListHeader}>{section.title}</Text>
              <View style={styles.allDevices}>
                <TouchableHighlight
                  underlayColor="transparent"
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  }}
                  onPress={() =>
                    this.toggleDevice(
                      null,
                      null,
                      section.manager,
                      this.state.modalMode,
                      section.data[0].deviceType
                    )
                  }
                >
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: 5,
                      // justifyContent: "space-between",
                    }}
                  >
                    <SimpleIcon
                      icon={
                        this.state.devicesStatus.some(
                          (d) =>
                            d.deviceId == null &&
                            d.manager == section.manager &&
                            d.triggerName.toLowerCase() ==
                              this.state.modalMode.toLowerCase()
                        )
                          ? faCharCodes.faCheckCircle
                          : this.getDeviceTypeIcon(section.data[0].deviceType)
                      }
                      size={22}
                      color={
                        this.state.devicesStatus.some(
                          (d) =>
                            d.deviceId == null &&
                            d.manager == section.manager &&
                            d.triggerName.toLowerCase() ==
                              this.state.modalMode.toLowerCase()
                        )
                          ? Theme.COLORS.SUCCESS
                          : Theme.COLORS.BLACK
                      }
                      style={styles.deviceListItemIcon}
                    />
                    <Text style={styles.allDevicesText}>
                      {translate("deviceGroup.ALL") +
                        " " +
                        translate("scenario." + section.manager)}
                    </Text>
                  </View>
                </TouchableHighlight>
              </View>

              {section.data.map((item, i) => {
                var isSelectedAll = this.state.devicesStatus.some(
                  (d) =>
                    (d.deviceId == null || d.deviceUId == null) &&
                    d.manager == section.manager &&
                    d.triggerName.toLowerCase() ==
                      this.state.modalMode.toLowerCase()
                );
                var isSelected = this.state.devicesStatus.some(
                  (d) =>
                    (d.deviceId == item.deviceId ||
                      d.deviceUId == item.deviceUId) &&
                    d.triggerName.toLowerCase() ==
                      this.state.modalMode.toLowerCase()
                );
                return (
                  <TouchableOpacity
                    key={i}
                    style={[
                      styles.sectionsItem,
                      isSelected
                        ? { backgroundColor: Theme.COLORS.PRIMARY + 15 }
                        : {},
                    ]}
                    onPress={() => {
                      !isSelectedAll &&
                        this.toggleDevice(
                          item.deviceId,
                          item.deviceUId,
                          section.manager,
                          this.state.modalMode,
                          item.deviceType
                        );
                    }}
                  >
                    <SimpleIcon
                      icon={
                        isSelectedAll
                          ? this.getDeviceTypeIcon(item.deviceType)
                          : isSelected
                          ? faCharCodes.faCheckCircle
                          : this.getDeviceTypeIcon(item.deviceType)
                      }
                      size={18}
                      color={
                        isSelectedAll
                          ? Theme.COLORS.MUTED
                          : isSelected
                          ? Theme.COLORS.SUCCESS
                          : Theme.COLORS.BLACK
                      }
                      style={styles.deviceListItemIcon}
                    />
                    <Text
                      style={
                        isSelectedAll
                          ? styles.deviceListItemMuted
                          : styles.deviceListItem
                      }
                    >
                      {item.deviceName}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          );
        })}
        <Text style={styles.deviceListHeader}>
          {translate("area.definedScenarios")}
        </Text>
        {scenarios.map((item, i) => {
          var isSelected = this.state.scenariosToRun.some(
            (s) =>
              s.scenarioId == item.id &&
              s.triggerName.toLowerCase() == this.state.modalMode.toLowerCase()
          );
          return (
            <TouchableOpacity
              key={i}
              style={[
                styles.sectionsItem,
                isSelected
                  ? { backgroundColor: Theme.COLORS.PRIMARY + 15 }
                  : {},
              ]}
              onPress={() =>
                this.toggleScenario(
                  item.id,
                  item.uId,
                  item.name,
                  this.state.modalMode
                )
              }
            >
              <SimpleIcon
                icon={
                  isSelected
                    ? faCharCodes.faCheckCircle
                    : faCharCodes.faDotCircle
                }
                size={18}
                color={isSelected ? Theme.COLORS.SUCCESS : Theme.COLORS.BLACK}
                style={styles.deviceListItemIcon}
              />

              <Text style={styles.deviceListItem}>{item.name}</Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    );
  };

  hideDeviceModal = () => {
    this.setState({ showPickDeviceModal: false });
  };

  showValidationAlert = () => {
    this.setState({ showingValidationErrors: true });
  };

  dismissValidationAlert = () => {
    this.setState({ showingValidationErrors: false });
  };

  showDeleteConfirm = () => {
    this.setState({ showingDeleteConfirm: true });
  };

  dismissDeleteConfirm = () => {
    this.setState({ showingDeleteConfirm: false });
  };

  handleDeleteConfirm = () => {
    this.dismissValidationAlert();
    this.props.removeState(
      this.state.id,
      this.state.uId,
      this.state.areaId,
      this.state.areaUId,
      this.state.accessToken
    );
    this.props.navigation.goBack();
  };

  render() {
    if (this.state.isLoading) return <Loading />;
    return (
      <View style={styles.wrapper}>
        {/** title */}
        <ScrollView style={styles.wrapper}>
          <View style={styles.sectionTitleRow}>
            <Text style={styles.areaName}>{this.state.areaName}</Text>
            {this.state.id > 0 && (
              <TouchableOpacity
                onPress={this.showDeleteConfirm}
                style={styles.deleteButton}
              >
                <SimpleIcon
                  icon={faCharCodes.faTrashAlt}
                  color="#FFF"
                  size={24}
                />
              </TouchableOpacity>
            )}
          </View>
          {/**state name */}
          <InputBase
            label={translate("areaState.stateName")}
            placeholder=""
            onChangeText={(txt) =>
              this.setState({
                name: txt,
                validation_stateName_hasError: txt.length == 0,
              })
            }
            value={this.state.name}
            isInvalid={this.state.validation_stateName_hasError}
            icon={faCharCodes.faEdit}
          />
          {/** canShowOnHomeScreenArea */}
          <View style={{ flexDirection: "row", marginVertical: 15 }}>
            <Switch
              isOn={this.state.canShowOnHomeScreenArea}
              onColor={Theme.COLORS.ACTIVE}
              offColor={Theme.COLORS.MUTED}
              size="small"
              onToggle={(v) => {
                this.setState({ canShowOnHomeScreenArea: v });
              }}
              animationSpeed={0}
            />
            <Text style={[styles.iosRtl, { flex: 1 }]}>
              {translate("areaState.canShowOnHomeScreenArea")}
            </Text>
          </View>
          {/** CanChangeByUsers */}
          <View style={{ flexDirection: "row", marginVertical: 15 }}>
            <Switch
              isOn={this.state.canChangeByUsers}
              onColor={Theme.COLORS.ACTIVE}
              offColor={Theme.COLORS.MUTED}
              size="small"
              onToggle={(v) => {
                this.setState({ canChangeByUsers: v });
              }}
              animationSpeed={0}
            />
            <Text style={[styles.iosRtl, { flex: 1 }]}>
              {translate("areaState.canChangeByUsers")}
            </Text>
          </View>
          {/** canShowOnHomeScreen */}
          <View style={{ flexDirection: "row", marginVertical: 15 }}>
            <Switch
              isOn={this.state.canShowOnHomeScreen}
              onColor={Theme.COLORS.ACTIVE}
              offColor={Theme.COLORS.MUTED}
              size="small"
              onToggle={(v) => {
                this.setState({ canShowOnHomeScreen: v });
              }}
              animationSpeed={0}
            />
            <Text style={[styles.iosRtl, { flex: 1 }]}>
              {translate("areaState.canShowOnHomeScreen")}
            </Text>
          </View>

          {/** shouldConfirm */}
          <View style={{ flexDirection: "row", marginVertical: 15 }}>
            <Switch
              isOn={this.state.shouldConfirm}
              onColor={Theme.COLORS.ACTIVE}
              offColor={Theme.COLORS.MUTED}
              size="small"
              onToggle={(v) => {
                this.setState({ shouldConfirm: v });
              }}
              animationSpeed={0}
            />
            <Text style={[styles.iosRtl, { flex: 1 }]}>
              {translate("areaState.shouldConfirm")}
            </Text>
          </View>
          <View>
            {/**on activation */}
            <View style={[styles.section, styles.activationSection]}>
              {/** title row */}
              <View style={styles.sectionTitleRow}>
                <Text
                  style={[styles.sectionTitle, styles.sectionTitleActivation]}
                >
                  {translate("areaState.onActivation")}:
                </Text>
                <TouchableHighlight
                  underlayColor={Theme.COLORS.SUCCESS + "55"}
                  style={styles.iconPickerPreview}
                  onPress={() => {
                    this.setState({
                      showOnActivationIconPicker:
                        !this.state.showOnActivationIconPicker,
                    });
                  }}
                >
                  <View style={styles.iconPickerPreview}>
                    <SimpleIcon
                      icon={this.state.activeIcon}
                      color={Theme.COLORS.PRIMARY}
                      size={28}
                      fontFamily={faCharCodes.FONT_FAMILIES.PRO_LIGHT}
                    />
                    <SimpleIcon
                      icon={
                        this.state.showOnActivationIconPicker
                          ? faCharCodes.faCaretUp
                          : faCharCodes.faCaretDown
                      }
                      size={12}
                      fontFamily={faCharCodes.FONT_FAMILIES.PRO_REGULAR}
                      style={{ paddingHorizontal: 5 }}
                    />
                  </View>
                </TouchableHighlight>
              </View>
              {/** icon picker */}
              {this.state.showOnActivationIconPicker && (
                <View>
                  <Text style={[styles.sectionTip, styles.iconPickerTip]}>
                    {translate("areaState.iconPickerTip", {
                      state: translate("areaState.active"),
                    })}
                  </Text>
                  <HorizontalIconPicker
                    icons={this.iconsList}
                    selectedIcon={this.state.activeIcon}
                    onSelect={(newIcon) => {
                      this.setState({ activeIcon: newIcon });
                    }}
                  />
                </View>
              )}
              {/** tip */}
              <Text style={[styles.sectionTitleActivation, styles.sectionTip]}>
                {translate("areaState.onActivationTip")}:
              </Text>
              {/** devices container */}
              <View style={styles.devicesContainer}>
                {this.state.devicesStatus
                  .filter(
                    (d) =>
                      d.triggerName.toLowerCase() ==
                      STATES.ON_ACTIVATE.toLowerCase()
                  )
                  .map((d, i) => {
                    var dvc = this.state.areaDevices.filter(
                      (ad) =>
                        ad.deviceId == d.deviceId || ad.deviceUId == d.deviceUId
                    )[0];
                    return (
                      <DeviceButton
                        key={i}
                        icon={this.getDeviceTypeIcon(
                          dvc?.deviceType || d.deviceType
                        )}
                        title={
                          dvc?.deviceName || translate("scenario." + d.manager)
                        }
                        deviceType={dvc?.deviceType || d.deviceType}
                        deviceId={dvc?.deviceId}
                        activeColor={Theme.COLORS.TL_YELLOW}
                        deActiveColor={Theme.COLORS.MUTED}
                        isActive={d.value == 255}
                        onPress={() => {
                          this.updateDeviceValue(
                            d.deviceId,
                            d.deviceUId,
                            STATES.ON_ACTIVATE
                          );
                        }}
                      />
                    );
                  })}
                {this.state.scenariosToRun
                  .filter(
                    (s) =>
                      s.triggerName.toLowerCase() ==
                      STATES.ON_ACTIVATE.toLowerCase()
                  )
                  .map((scn, i) => {
                    return (
                      <DeviceButton
                        key={i}
                        icon={faCharCodes.faMagic}
                        title={scn.scenarioName}
                        deviceType={"SCENARIO"}
                        activeColor={Theme.COLORS.TL_PURPLE}
                        deActiveColor={Theme.COLORS.MUTED}
                        isActive={true}
                      />
                    );
                  })}
                <DeviceButton
                  icon={
                    this.state.devicesStatus.some(
                      (d) =>
                        d.triggerName.toLowerCase() ==
                        STATES.ON_ACTIVATE.toLowerCase()
                    )
                      ? faCharCodes.faEdit
                      : faCharCodes.faPlusCircle
                  }
                  activeColor={Theme.COLORS.SUCCESS}
                  onPress={() => this.showDeviceModal(STATES.ON_ACTIVATE)}
                />
              </View>
            </View>

            {/**on deactivation */}
            <View style={[styles.section, styles.deactivationSection]}>
              {/** title row */}
              <View style={styles.sectionTitleRow}>
                <Text
                  style={[styles.sectionTitle, styles.sectionTitleDeactivation]}
                >
                  {translate("areaState.onDeactivation")}:
                </Text>
                <TouchableHighlight
                  underlayColor={Theme.COLORS.WARNING + "55"}
                  style={styles.iconPickerPreview}
                  onPress={() => {
                    this.setState({
                      showOnDeActivationIconPicker:
                        !this.state.showOnDeActivationIconPicker,
                    });
                  }}
                >
                  <View style={styles.iconPickerPreview}>
                    <SimpleIcon
                      icon={this.state.deActiveIcon}
                      color={Theme.COLORS.PRIMARY}
                      size={28}
                      fontFamily={faCharCodes.FONT_FAMILIES.PRO_LIGHT}
                    />
                    <SimpleIcon
                      icon={
                        this.state.showOnDeActivationIconPicker
                          ? faCharCodes.faCaretUp
                          : faCharCodes.faCaretDown
                      }
                      size={12}
                      fontFamily={faCharCodes.FONT_FAMILIES.PRO_REGULAR}
                      style={{ paddingHorizontal: 5 }}
                    />
                  </View>
                </TouchableHighlight>
              </View>
              {/** icon picker */}
              {this.state.showOnDeActivationIconPicker && (
                <View>
                  <Text style={[styles.sectionTip, styles.iconPickerTip]}>
                    {translate("areaState.iconPickerTip", {
                      state: translate("areaState.deActive"),
                    })}
                  </Text>
                  <HorizontalIconPicker
                    icons={["", ...this.iconsList]}
                    selectedIcon={this.state.deActiveIcon}
                    onSelect={(newIcon) => {
                      this.setState({ deActiveIcon: newIcon });
                    }}
                  />
                </View>
              )}
              {/** tip */}
              <Text
                style={[styles.sectionTitleDeactivation, styles.sectionTip]}
              >
                {translate("areaState.onDeactivationTip")}:
              </Text>
              {/** devices container */}
              <View style={styles.devicesContainer}>
                {this.state.devicesStatus
                  .filter(
                    (d) =>
                      d.triggerName.toLowerCase() ==
                      STATES.ON_DEACTIVATE.toLowerCase()
                  )
                  .map((d, i) => {
                    var dvc = this.state.areaDevices.filter(
                      (ad) => ad.deviceId == d.deviceId
                    )[0];
                    return (
                      <DeviceButton
                        key={i}
                        icon={this.getDeviceTypeIcon(
                          dvc?.deviceType || d.deviceType
                        )}
                        title={
                          dvc?.deviceName || translate("scenario." + d.manager)
                        }
                        deviceType={dvc?.deviceType || d.deviceType}
                        deviceId={dvc?.deviceId}
                        activeColor={Theme.COLORS.TL_YELLOW}
                        deActiveColor={Theme.COLORS.MUTED}
                        isActive={d.value == 255}
                        onPress={() => {
                          this.updateDeviceValue(
                            d.deviceId,
                            d.deviceUId,
                            STATES.ON_DEACTIVATE
                          );
                        }}
                      />
                    );
                  })}
                {this.state.scenariosToRun
                  .filter(
                    (s) =>
                      s.triggerName.toLowerCase() ==
                      STATES.ON_DEACTIVATE.toLowerCase()
                  )
                  .map((scn, i) => {
                    return (
                      <DeviceButton
                        key={i}
                        icon={faCharCodes.faMagic}
                        title={scn.scenarioName}
                        deviceType={"SCENARIO"}
                        activeColor={Theme.COLORS.TL_PURPLE}
                        deActiveColor={Theme.COLORS.MUTED}
                        isActive={true}
                      />
                    );
                  })}
                <DeviceButton
                  icon={
                    this.state.devicesStatus.some(
                      (d) =>
                        d.triggerName.toLowerCase() ==
                        STATES.ON_DEACTIVATE.toLowerCase()
                    )
                      ? faCharCodes.faEdit
                      : faCharCodes.faPlusCircle
                  }
                  activeColor={Theme.COLORS.WARNING}
                  onPress={() => this.showDeviceModal(STATES.ON_DEACTIVATE)}
                />
              </View>
            </View>
          </View>

          {/** auto disabling */}
          <View style={styles.autoDisableWrapper}>
            <View style={{ flexDirection: "row", marginBottom: 10 }}>
              <Switch
                isOn={this.state.autoDisable}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  if (v) {
                    this.setState({ autoDisable: true });
                  } else {
                    this.setState({
                      autoDisable: false,
                      autoDisableIntervalDuration: 0, // reset to zero
                    });
                  }
                }}
                animationSpeed={0}
              />
              <Text style={[styles.iosRtl, { flex: 1 }]}>
                {translate("areaState.autoDisabling")}
              </Text>
            </View>
            {this.state.autoDisable == true && (
              <View style={{ marginStart: 15 }}>
                {/* interval picker */}
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      width: 45,
                      marginEnd: 5,
                      color: Theme.COLORS.MUTED,
                    }}
                  >
                    {translate("timer.after")}
                  </Text>
                  <View style={{ width: 100 }}>
                    <InputBase
                      keyboardType="numeric"
                      inputStyle={{ height: 45 }}
                      placeholder=" "
                      onChangeText={(txt) => {
                        var duration = Number(txt) || 0;
                        this.setState({
                          autoDisableIntervalDuration: duration,
                          validation_duration_hasError: duration <= 0,
                        });
                      }}
                      value={this.state.autoDisableIntervalDuration.toString()}
                    />
                  </View>
                  <View style={{ flex: 1, marginEnd: 10 }}>
                    <Select
                      data={this.allIntervalTypes.map((v) => {
                        return { value: v, label: translate(`timer.${v}`) };
                      })}
                      value={
                        this.state.autoDisableIntervalType ||
                        this.allIntervalTypes[0]
                      }
                      onChangeText={(value, index, data) => {
                        this.setState({ autoDisableIntervalType: value });
                      }}
                    />
                  </View>
                </View>
              </View>
            )}
          </View>
        </ScrollView>

        {/** device modal */}
        {this.state.showPickDeviceModal && (
          <ModalBase
            isOpen={this.state.showPickDeviceModal}
            onClose={this.hideDeviceModal}
            contentStyle={{ height: "100%" }}
          >
            <View style={styles.modalWrapper}>
              {this.renderModalList()}

              <ArButton
                color="primary"
                onPress={this.hideDeviceModal}
                style={{ marginBottom: 0 }}
              >
                {translate("app.confirm")}
              </ArButton>
            </View>
          </ModalBase>
        )}

        {/** validation messages */}
        {this.state.showingValidationErrors && (
          <AlertDialogBase
            isOpen={true}
            cancelText={translate("app.close")}
            cancelVariant="outline"
            onClose={() => this.dismissValidationAlert()}
          >
            <Text>{" - " + this.state.validationErrors.join("\r\n - ")}</Text>
          </AlertDialogBase>
        )}
        {/** delete confirm */}
        {this.state.showingDeleteConfirm && (
          <AlertDialogBase
            isOpen={true}
            confirmText={translate("app.confirm")}
            colorConfirm="error"
            confirmHandler={this.handleDeleteConfirm}
            onClose={this.dismissDeleteConfirm}
          >
            <Text>
              {translate("areaState.deleteConfirmMessage", {
                state: this.state.name,
              })}
            </Text>
          </AlertDialogBase>
        )}
        {/**submit buttons */}
        <HStack space={2} style={styles.btnSubmitHolder}>
          <ArButton
            color="primary"
            style={{ flex: 1 }}
            onPress={() => this.save()}
          >
            {translate("app.save")}
          </ArButton>
          <ArButton
            variant="outline"
            color="muted"
            style={{ flex: 1 }}
            onPress={() => this.props.navigation.goBack()}
          >
            {translate("app.goBack")}
          </ArButton>
        </HStack>
      </View>
    );
  }
}

/**@augments{Component<Props,state>} */
class DeviceButton extends Component {
  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    isActive: PropTypes.bool,
    deviceType: PropTypes.string,
    activeColor: PropTypes.string,
    deActiveColor: PropTypes.string,
    onPress: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnPress = () => {
    typeof this.props.onPress == "function" && this.props.onPress();
  };

  getActiveText = (deviceType, deviceId) => {
    if (deviceId) {
      switch (deviceType) {
        case DeviceTypes.CURTAIN:
          return translate("scenario.Open");
        case DeviceTypes.ELEVATOR:
          return "";
        case DeviceTypes.DOORLOCK:
          return translate("scenario.Open");
        case "SCENARIO":
          return translate("scenario.execute");
        case DeviceTypes.LIGHT:
        case DeviceTypes.LIGHT_DIMMER:
        case DeviceTypes.OUTLET:
        case DeviceTypes.AIR_CONDITIONER:
        case DeviceTypes.WATERING_SWITCH:
        case DeviceTypes.POWER_SWITCH:
        case DeviceTypes.HIDDEN_SWITCH:
        default:
          return translate("scenario.TurnOn");
      }
    }

    switch (deviceType) {
      case DeviceTypes.DOORLOCK:
      case DeviceTypes.CURTAIN:
        return translate("scenario.OpenAllDoors");
      case "SCENARIO":
        return translate("scenario.execute");
      case DeviceTypes.LIGHT:
      case DeviceTypes.LIGHT_DIMMER:
      case DeviceTypes.OUTLET:
      case DeviceTypes.AIR_CONDITIONER:
      case DeviceTypes.WATERING_SWITCH:
      case DeviceTypes.POWER_SWITCH:
      case DeviceTypes.HIDDEN_SWITCH:
      default:
        return translate("scenario.TurnOnAll");
    }
  };
  getDeActiveText = (deviceType, deviceId) => {
    if (deviceId) {
      switch (deviceType) {
        case DeviceTypes.CURTAIN:
          return translate("scenario.Close");
        case DeviceTypes.ELEVATOR:
          return "";
        case DeviceTypes.DOORLOCK:
          return "";
        case "SCENARIO":
          return translate("scenario.execute");
        case DeviceTypes.LIGHT:
        case DeviceTypes.LIGHT_DIMMER:
        case DeviceTypes.OUTLET:
        case DeviceTypes.AIR_CONDITIONER:
        case DeviceTypes.WATERING_SWITCH:
        case DeviceTypes.POWER_SWITCH:
        case DeviceTypes.HIDDEN_SWITCH:
        default:
          return translate("scenario.TurnOff");
      }
    }
    switch (deviceType) {
      case DeviceTypes.LIGHT:
      case DeviceTypes.LIGHT_DIMMER:
      case DeviceTypes.OUTLET:
      case DeviceTypes.AIR_CONDITIONER:
      case DeviceTypes.WATERING_SWITCH:
      case DeviceTypes.POWER_SWITCH:
      case DeviceTypes.HIDDEN_SWITCH:
      default:
        return translate("scenario.TurnOffAll");
    }
  };

  render() {
    let {
      isActive,
      activeColor,
      deActiveColor,
      deviceType,
      deviceId,
      title,
      icon,
    } = this.props;
    if (!activeColor) activeColor = Theme.COLORS.TL_YELLOW;
    if (!deActiveColor) deActiveColor = activeColor;
    var activeText = this.getActiveText(deviceType, deviceId);
    var deActiveText = this.getDeActiveText(deviceType, deviceId);
    return (
      <TouchableOpacity
        style={[
          styles.deviceButton,
          // { backgroundColor: isActive ? activeColor + "33" : "#FFF" },
          { backgroundColor: Theme.COLORS.WHITE },
        ]}
        onPress={this.handleOnPress}
      >
        <IconButton
          icon={{
            code: icon,
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
              fontSize: 28,
              //color:  "#FFF",
              color: isActive ? activeColor : deActiveColor,
            },
            caption: {
              text: `${title}\r\n${isActive ? activeText : deActiveText}`,
              styles: { textAlign: "center" },
            },
          }}
          onPress={this.handleOnPress}
        />
        {title != undefined && (
          <Text
            numberOfLines={1}
            ellipsizeMode={"middle"}
            style={styles.deviceButtonText}
          >
            {title}
          </Text>
        )}
        {title != undefined && isActive && (
          <Text style={styles.deviceButtonText}>{activeText}</Text>
        )}
        {title != undefined && !isActive && (
          <Text style={styles.deviceButtonText}>{deActiveText}</Text>
        )}
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 10,
  },
  allDevicesText: {
    marginTop: 10,
    // fontWeight: "bold",
    marginEnd: -10,
    fontSize: 20,
    paddingEnd: 10,
  },
  allDevices: {
    paddingTop: 5,
    paddingEnd: 5,
    borderBottomColor: Theme.COLORS.BORDER_COLOR,
    borderBottomWidth: 1,
    flex: 1,
    alignItems: "flex-start",
    // justifyContent: "space-between",
    flexDirection: "row",
  },
  areaName: {
    fontWeight: "bold",
    fontSize: 18,
    marginVertical: 10,
  },
  sectionTitleRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: 18,
    padding: 8,
    flex: 1,
  },
  iconPickerPreview: {
    flexDirection: "row",
    width: 60,
    paddingHorizontal: 3,
    //backgroundColor: "#",
    backfaceVisibility: "hidden",
    alignItems: "center",
    justifyContent: "space-between",
  },
  iconPicker: {
    width: 100,
    fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
  },
  iconPickerTip: {
    backgroundColor: Theme.COLORS.BORDER_COLOR,
  },
  sectionTip: {
    fontSize: 12,
    color: "#333",
    paddingEnd: 8,
    paddingBottom: 8,
  },
  sectionTitleActivation: {
    color: Theme.COLORS.SUCCESS,
    backgroundColor: Theme.COLORS.SUCCESS + "22",
  },
  sectionTitleDeactivation: {
    color: Theme.COLORS.WARNING,
    backgroundColor: Theme.COLORS.WARNING + "22",
  },
  section: {
    // flex: 1,
    borderColor: Theme.COLORS.BORDER_COLOR,
    borderWidth: 1,
    marginBottom: 15,
    //padding: 10,
    minHeight: HEIGHT / 3 - 40,
    borderRadius: 2,
  },
  activationSection: {
    borderColor: Theme.COLORS.SUCCESS + "88",
    borderWidth: 1,
    backgroundColor: Theme.COLORS.SUCCESS + "11",
  },
  deactivationSection: {
    borderColor: Theme.COLORS.WARNING + "88",
    borderWidth: 1,
    backgroundColor: Theme.COLORS.WARNING + "11",
  },
  btnSubmitHolder: {
    flexDirection: "row",
    paddingHorizontal: 5,
  },
  btnSubmit: {
    flex: 1,
    marginVertical: 10,
    marginHorizontal: 5,
    //width: "90%",
  },
  devicesContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    //justifyContent: "center",
    paddingVertical: 10,
  },
  deviceButton: {
    padding: 5,
    margin: 5,
    borderRadius: 5,
    width: 80,
    height: 80,
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset:
      Platform.OS == "web"
        ? { width: 5, height: 5 }
        : { width: 15, height: 15 },
    shadowOpacity: Platform.OS == "web" ? 0.2 : 0.5,
    shadowRadius: Platform.OS == "web" ? 5 : 15,
    elevation: 3,
  },
  deleteButton: {
    backgroundColor: Theme.COLORS.ERROR,
    width: 46,
    height: 46,
    borderRadius: 23,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset:
      Platform.OS == "web"
        ? { width: 5, height: 5 }
        : { width: 50, height: 50 },
    shadowOpacity: Platform.OS == "web" ? 0.2 : 1,
    shadowRadius: 15,
    elevation: Platform.OS == "web" ? 5 : 10,
  },
  deviceButtonText: {
    textAlign: "center",
    fontSize: 10,
  },
  modalWrapper: {
    flex: 1,
    padding: 10,
  },
  deviceListHeader: {
    fontSize: 24,
    fontWeight: "bold",
    color: Theme.COLORS.MUTED,
    marginBottom: 5,
    marginStart: 10,
  },
  deviceListItem: {
    flex: 1,
    // height: 42,
    // borderBottomColor: Theme.COLORS.BORDER_COLOR,
    // borderBottomWidth: 1,
    textAlignVertical: "center",
    marginStart: 5,
  },
  deviceListItemMuted: {
    flex: 1,
    // height: 42,
    // borderBottomColor: Theme.COLORS.BORDER_COLOR,
    // borderBottomWidth: 1,
    textAlignVertical: "center",
    marginStart: 5,
    color: Theme.COLORS.MUTED,
  },
  deviceListItemIcon: {
    textAlignVertical: "center",
    // height: 42,
    marginStart: 20,
  },
  autoDisableWrapper: { marginVertical: 15 },
  iosRtl: {
    marginHorizontal: 5,
    alignItems: "center",
    textAlign: Platform.OS == "ios" ? "left" : "auto",
  },
  sectionsItem: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: 40,
    backgroundColor: Theme.COLORS.GRAY_LIGHT,
    padding: 5,
    borderRadius: 5,
    marginBottom: 5,
  },
});

function mapStateToProps(state) {
  return {
    AreaReducer: state.AreaReducer,
    DeviceReducer: state.DeviceReducer,
    ScenarioReducer: state.ScenarioReducer,
    AppReducer: state.AppReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addState: (model, accessToken) =>
      dispatch(AreaActions.AddState(model, accessToken)),
    updateState: (model, accessToken) =>
      dispatch(AreaActions.UpdateState(model, accessToken)),
    removeState: (stateId, stateUId, areaId, areaUId, accessToken) =>
      dispatch(
        AreaActions.RemoveState(stateId, stateUId, areaId, areaUId, accessToken)
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AreaStateFormScreen);
